/**
 * Admin authentication service.
 */
import { getBaseUrl } from './utils';

const STORAGE_KEY_TOKEN = 'admin_access_token';
const STORAGE_KEY_EXPIRES = 'admin_access_token_expires_at_ms';

export function getAdminAccessToken(): string {
  return localStorage.getItem(STORAGE_KEY_TOKEN) || '';
}

export function getAdminTokenExpiresAtMs(): number {
  const raw = localStorage.getItem(STORAGE_KEY_EXPIRES) || '';
  return Number(raw) || 0;
}

export function clearAdminSession(): void {
  localStorage.removeItem(STORAGE_KEY_TOKEN);
  localStorage.removeItem(STORAGE_KEY_EXPIRES);
}

export function isAdminSessionExpired(): boolean {
  const token = getAdminAccessToken();
  const expiresAt = getAdminTokenExpiresAtMs();
  if (!token || !expiresAt) return true;
  return Date.now() >= expiresAt - 3000;
}

export async function adminLogin(username: string, password: string): Promise<{
  accessToken: string;
  expiresIn: number;
}> {
  const baseUrl = getBaseUrl();
  const response = await fetch(`${baseUrl}/api/admin/auth/login`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ username, password }),
  });

  if (!response.ok) {
    const error = await response.json().catch(() => ({}));
    throw new Error(error.detail || 'Login failed');
  }

  const data = await response.json();
  const { access_token, expires_in } = data;
  const expiresAtMs = Date.now() + expires_in * 1000;

  localStorage.setItem(STORAGE_KEY_TOKEN, access_token);
  localStorage.setItem(STORAGE_KEY_EXPIRES, String(expiresAtMs));

  return { accessToken: access_token, expiresIn: expires_in };
}
